<div class="clearfix">
  <div class="float-left">
    <h1>
      {{ id === 0 ? 'Create' : 'Edit' }} User
      <!-- Display the user name if we have a first name value -->
      @if (formGroup.value.firstName) {
        <span
          >- {{ formGroup.value.firstName }} {{ formGroup.value.lastName }}</span
          >
        }
      </h1>
    </div>
    @if (canViewReports && id !== 0) {
      <div id="pageActions">
        <button
          (click)="openWindow('administration/users/user-audit-history/' + id)"
          aria-label="Audit History"
          ngbTooltip="Audit History"
          class="page-action float-right"
          pcg-svg-history
        ></button>
        <button
			(click)="openWindow('administration/security/security-reports/user-permissions?userId=' + id)"
			aria-label="View User Security"
			ngbTooltip="View User Security"
			class="page-action report float-right"
		></button>
	</div>
}
</div>
<hr />

<ul ngbNav #nav="ngbNav" class="nav-tabs">
	<!-- Details -->
	<li ngbNavItem="Details">
		<a ngbNavLink>Details</a>
		<ng-template ngbNavContent>
			<form
				pcgSubmitUrl="api/Administration/Users/SaveUser"
				(messageReceive)="saveUser($event)"
				[formGroup]="formGroup"
			>
				<pcg-collapsible-divider header="User Details">
					<input type="hidden" formControlName="userId" />
					<div class="row">
						<pcg-control-group class="col-md-4" label="First Name">
							<input pcgControlRef class="form-control" type="text" formControlName="firstName" />
						</pcg-control-group>
						<pcg-control-group class="col-md-4" label="Last Name">
							<input pcgControlRef class="form-control" type="text" formControlName="lastName" />
						</pcg-control-group>
						<pcg-control-group class="col-md-4" label="Username">
							<input pcgControlRef class="form-control" type="text" formControlName="userName" />
						</pcg-control-group>
					</div>
					<div class="row">
						<pcg-control-group class="col-md-4" label="Email">
							<input pcgControlRef class="form-control email" type="text" formControlName="email" />
						</pcg-control-group>
						<pcg-control-group class="col-md-4" label="Phone">
							<input
								pcgPhoneExt
								pcgControlRef
								class="form-control"
								type="text"
								formControlName="phoneNumber"
								maxlength="21"
								mask="(000) 000-0000 x99999"
							/>
						</pcg-control-group>
						@if (canSeePasswordButtons) {
<div class="col-md-4">
							@if (canResetPassword) {
<input
								type="button"
								(click)="resetPassword(false)"
							
								class="btn btn-save btn-lg"
								ngbTooltip="Send user a reset password email with their username and the ability to choose a new password."
								value="Reset Password"
								id="btnResetPassword"
							/>
}
							<br />
							@if (canSendWelcomeEmail) {
<input
								type="button"
								(click)="resetPassword(true)"
							
								class="btn btn-save btn-lg"
								ngbTooltip="Send user a welcome email with their username and the ability to choose a new password."
								value="Send Welcome Email"
								id="btnSendWelcomeMessage"
							/>
}
						</div>
}
					</div>
				</pcg-collapsible-divider>
				<pcg-collapsible-divider header="Security">
					<div class="row">
						<div class="col-md-6">
							<pcg-control-group>
								<label for="userProfileIds" class="for">Security Profiles</label>
								<pcg-select
									labelForId="userProfileIds"
									[sendFormData]="false"
									pcgControlRef
									[multiple]="true"
									[dataSource]="'api/Select/UserProfiles?userId=' + id"
									formControlName="userProfileIds"
								></pcg-select>
								@if (isCurrentUser) {
<input
									type="button"
									id="btnChangePassword"
									value="Change Password"
									(click)="openChangePasswordModal()"
								
									class="btn btn-save btn-lg"
								/>
}
							</pcg-control-group>
							@if (isLockedOut && canUnlock) {
<div id="divUnlockUser">
								<br />
								<span
									role="button"
									aria-label="Unlock"
									(click)="unlockUser()"
									ngbTooltip="This user is locked out. Click here to unlock the user and send them an email with login instructions."
									class="unlock"
									id="spanUnlockUser"
								>
									<svg
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink"
										width="30"
										height="30"
										viewBox="0 0 30 30"
									>
										<g id="icomoon-ignore">
											<line stroke-width="1" x1="" y1="" x2="" y2="" opacity=""></line>
										</g>
										<path
											d="M22.5 1.875h-3.75c-3.102 0-5.625 2.523-5.625 5.625v5.625h-11.719c-0.773 0-1.406 0.633-1.406 1.406v14.063c0 0.773 0.633 1.406 1.406 1.406h15.938c0.773 0 1.406-0.633 1.406-1.406v-14.063c0-0.773-0.633-1.406-1.406-1.406h-0.469v-5.625c0-1.034 0.841-1.875 1.875-1.875h3.75c1.034 0 1.875 0.841 1.875 1.875v5.625h3.75v-5.625c0-3.102-2.523-5.625-5.625-5.625zM11.25 26.25h-3.75l0.816-4.078c-0.492-0.338-0.816-0.905-0.816-1.547 0-1.036 0.839-1.875 1.875-1.875s1.875 0.839 1.875 1.875c0 0.642-0.323 1.209-0.816 1.547l0.816 4.078z"
										></path>
									</svg>
								</span>
							</div>
}
							<br />@if (isCurrentUser) {
<br />
}
							<pcg-control-group>
								<div class="form-check">
									<input
										pcgControlRef
										id="isActive"
										class="form-check-input"
										formControlName="isActive"
										type="checkbox"
									/>
									<label for="isActive" class="form-check-label">Is Active?</label>
								</div>
							</pcg-control-group>
							<pcg-control-group>
								<div class="form-check">
									<input
										pcgControlRef
										id="canChangeSecurity"
										class="form-check-input"
										formControlName="canChangeSecurity"
										type="checkbox"
									/>
									<label for="canChangeSecurity" class="form-check-label">Can Change Security?</label>
								</div>
							</pcg-control-group>
						</div>
					</div>
				</pcg-collapsible-divider>
				<br />
				<pcg-fixed-buttons>
					@if (!isCurrentUser || canEdit) {
<a
					
						class="btn btn-cancel btn-lg"
						routerLink="/administration/users"
						>Back</a
					>
}
					<button class="btn btn-save btn-lg">Save</button>
				</pcg-fixed-buttons>
			</form>
		</ng-template>
	</li>

	<!-- 2FA -->
	@if (id !== 0 && formGroup) {
<li ngbNavItem="Multi-Factor Authentication">
		<a ngbNavLink>Multi-Factor Authentication</a>
		<ng-template ngbNavContent>
			<!-- This component is in the user-multi-factor-authentication directory under the edit-user component's directory -->
			<pcg-user-multi-factor-authentication [id]="id"></pcg-user-multi-factor-authentication>
		</ng-template>
	</li>
}

	<!-- Login History -->
	@if (id !== 0 && canViewLoginHistory) {
<li ngbNavItem="Login History">
		<a ngbNavLink>Login History</a>
		<ng-template ngbNavContent>
			<!-- This component is in the user-login-history directory under the edit-user component's directory -->
			<pcg-user-login-history [id]="id"></pcg-user-login-history>
		</ng-template>
	</li>
}
</ul>
<div [ngbNavOutlet]="nav"></div>
